import React from 'react';

const PanelSeparator = ({className}) => {
  return (
    <div className={`PanelSeparator ${className}`}/>
  );
};

export default PanelSeparator;
